import { render, staticRenderFns } from "./PRichOGPCard.vue?vue&type=template&id=8bdfbc34&scoped=true&"
import script from "./PRichOGPCard.vue?vue&type=script&lang=ts&"
export * from "./PRichOGPCard.vue?vue&type=script&lang=ts&"
import style0 from "./PRichOGPCard.vue?vue&type=style&index=0&id=8bdfbc34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdfbc34",
  null
  
)

export default component.exports